<template>
  <div :style="{ width: appWidth }" ref="app" id="app">
    <router-view />
  </div>
</template>

<script>
var screenHeight = 0;
var scrollTop = 0,
  scrollBototm = screenHeight;
var preTop = 0,
  timer = null,
  scrolln = 0; // 延时器
export default {
  name: "App",
  data() {
    return {
      routerQuery: {},
      appWidth: "100%",
    };
  },
  created() {
    let _ua = navigator.userAgent.toLowerCase();
    let _testUa = (regexp) => regexp.test(_ua);
    if (
      _testUa(/android|adr/g) ||
      _testUa(/ios|iphone|ipad|ipod|iwatch/g) ||
      _testUa(/mobile/g)
    ) {
      //移动
    } else {
      //pc
      document.documentElement.style.fontSize = "37.5px";
      this.appWidth = "500px";
    }
    this.routerQuery = {};
    if (window.location.hash.split("?")[1]) {
      window.location.hash
        .split("?")[1]
        .split("&")
        .map((item, idx) => {
          let key = item.split("=")[0];
          let val = item.split("=")[1];
          this.routerQuery[key] = val;
        });
    }
    let router = window.location;
    let isRootPath = router.hash.split("?")[0].split("/")[1];
    let routerParams = "";
    if (window.location.hash.split("?")[1]) {
      routerParams = "?";
      let arr = window.location.hash.split("?")[1].split("&");
      for (let i = 0; i < arr.length; i++) {
        if (!arr[i].includes("channel")) {
          routerParams += arr[i] + "&";
        }
      }
    }
    if (isRootPath == "") {
      let path = "";
      if (this.routerQuery.channel) {
        path = this.routerQuery.channel;
      } else {
        path = "";
      }
      path += routerParams;
      // console.log(`我希望在这里增加日志1`,path)
      //  console.log(`我希望在这里增加日志2`,routerParams)

      this.$router.push({ path });
    }
  },
  mounted() {
    scrollBototm = screenHeight = this.$refs.app.offsetHeight;
  },
  methods: {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue